import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'toMinSec',
    standalone: false
})
export class TransformSecToMinPipe implements PipeTransform {
  transform(value) {
    const minutes = DateTime.now().startOf('day').plus({ seconds: value });
    return minutes.toFormat('mm:ss');
  }
}
